import React from 'react'
import UseStyles from './styles'
import AppBar from "@material-ui/core/AppBar";
import Button from "@material-ui/core/Button";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import kardiaOperationsLogo from "../../../assets/images/kardia_operations_logo.svg";
// import LinearProgress from '@material-ui/core/LinearProgress';
// import { useSelector, useDispatch} from "react-redux";
// import {startLoading} from '../../../store/actions'
import { logout } from '../../../store/actions/auth';

const AppHeader = () => {
  const classes = UseStyles();
  // const store = useSelector(state => state)
  // const dispatch = useDispatch()
  // //console.log(store.loading)

  const handleSignOut = (e) => {
    e.preventDefault()
    logout()
  }

  return (
    <AppBar position="static" elevation={0} className={classes.appBar}>
      <Toolbar className={classes.toolbar}>
        <img
          src={kardiaOperationsLogo}
          className={classes.toolbarTitleImage}
          alt="Kardia logo"
        />
        <Typography
          variant="h6"
          color="inherit"
          noWrap
          className={classes.toolbarTitle}
        >
        </Typography>
        <Button
          onClick={handleSignOut}
          color="secondary"
          variant="contained"
          className={classes.link}
          disableElevation
        >
          Signout
        </Button>
      </Toolbar>
      {/* {loading && <LinearProgress />} */}
    </AppBar>
  );
}

export default AppHeader
